module.exports = __webpack_public_path__ + "files/2d107e4984b6efe9846e6ce8d5d8c2ad.png";